import {inject, Injectable} from "@angular/core";
import * as ProviderActions from "@core/ngrx/actions/provider.actions";
import {Action, Store} from "@ngrx/store";
import {PaginatedResultModel} from "@core/model/paginated-result.model";
import {Provider} from "@core/model/providers";
import {Actions, ofType} from "@ngrx/effects";
import {map, mergeMap, Observable, of, shareReplay, switchMap, take, throwError} from "rxjs";
import {selectLocalProvidersState} from "@core/ngrx/selectors/aux/provider.selectors";
import {combine} from "@turf/turf";
import {concat} from "lodash";

@Injectable({providedIn: 'root'})
export class ProvidersFacade {
  private store = inject(Store)
  private actions$ = inject(Actions);

  public loadGlobalProviders(): void {
    this.store.dispatch(ProviderActions.loadGlobalProviders({
      params: {page: 1, limit: 0}
    }));
  }

  public loadProviders(mapId: string): void {
    this.store.dispatch(ProviderActions.loadProviders({
      mapId: mapId
    }));
  }

  public handleProvidersConfigurationUsingGlobalProviders$(mapId: string): Observable<any> {
    this.loadGlobalProviders();
    this.loadProviders(mapId);
    const providers$ = this.store.select(selectLocalProvidersState);
    const globalProvidersResult$ = this.actions$.pipe(
      ofType(ProviderActions.loadGlobalProvidersSuccess, ProviderActions.loadGlobalProvidersFailure),
      take(1),
      mergeMap(a => a.type == ProviderActions.loadGlobalProvidersSuccess.type ? of(a.response) : throwError(() => "")),
      shareReplay(1)
    );

    return globalProvidersResult$.pipe(
      switchMap(globalProviders =>
        providers$.pipe(
          map(providers => this.store.dispatch(ProviderActions.getProvidersConfiguration({
            localProviders: providers,
            globalProviders: globalProviders.data
          })))
        )
      )
    );
  }

  //listeners
  public listenToLoadGlobalProviders$(): Observable<PaginatedResultModel<Provider>> {
    return this.actions$.pipe(
      ofType(ProviderActions.loadGlobalProvidersSuccess),
      map(action => action.response)
    );
  }

  public listenToLoadProvidersConfiguration$(): Observable<{
    localProviders: Provider[],
    globalProviders: Provider[]
  }> {
    return this.actions$.pipe(
      ofType(ProviderActions.getProvidersConfiguration),
      map(action => {
        return {localProviders: action.localProviders, globalProviders: action.globalProviders}
      })
    )
  }

}
